import { useEffect, useRef, useState } from 'react';
import { getViralLinkIframeSrc } from '../utils/urls';
import { onIframeResizeMessage } from '../utils/postMessageUtils';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledIframe = styled.iframe.withConfig({
  displayName: "EmbeddedViralLink__StyledIframe",
  componentId: "sc-1dd9rss-0"
})(["border:0;"]);
export default function EmbeddedViralLink({
  langOverride,
  linkType,
  portalId,
  additionalParams
}) {
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState();
  useEffect(() => {
    onIframeResizeMessage({
      iframeRef,
      onMessage: value => {
        setIframeHeight(parseInt(value, 10));
      }
    });
  }, [iframeRef]);
  return (
    /*#__PURE__*/
    //@bend-expect trellis-tokenized
    _jsx(StyledIframe, {
      width: "100%",
      height: iframeHeight || 0,
      "aria-label": `hubspot-${linkType}-viral-iframe`,
      "data-test-id": "viral-link-iframe",
      ref: iframeRef,
      src: getViralLinkIframeSrc(linkType, Object.assign({
        lang: langOverride,
        portalId
      }, additionalParams))
    })
  );
}